import { render, staticRenderFns } from "./NewPasswordPage.vue?vue&type=template&id=706b0414&"
import script from "./NewPasswordPage.vue?vue&type=script&lang=js&"
export * from "./NewPasswordPage.vue?vue&type=script&lang=js&"
import style0 from "./NewPasswordPage.vue?vue&type=style&index=0&id=706b0414&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports